export const QuestionTypes = {
    QUESTION_BY_CATEGORY : "QUESTION_BY_CATEGORY",
    ADD_QUESTION:"ADD_QUESTION",
    EDIT_QUESTION:"EDIT_QUESTION",
    DELETE_QUESTION:"DELETE_QUESTION"
}